import { USER_VERIFY_REQUEST, USER_VERIFY_SUCCESS, USER_VERIFY_FAILURE} from "./constants";

const initialState = {
    verifying: false,
    verified: false,
    alreadyDeleted: false
};

const verifyUserReducer = (state = initialState, action) => {

    switch (action.type) {
        case USER_VERIFY_REQUEST:
            return Object.assign({}, state, {verifying: true});
        case USER_VERIFY_SUCCESS:
            return Object.assign({}, state, {verifying: false, verified: true, alreadyDeleted:false});
        case USER_VERIFY_FAILURE:
            return Object.assign({}, state, {verifying: false, verified: false, alreadyDeleted: action.data.error.message});
        default:
            return state;
    }
};

export default verifyUserReducer;


// WEBPACK FOOTER //
// ./src/containers/Layouts/Default/VerifyUser/reducer.js